interface ICategory {
	name: string;
	i18N: {
		DE: string
	}
}

export function getCategoryName<Category extends ICategory>(category: Category | null | undefined, locale: string) {
	if (!category) {
		return "";
	}

	if (locale === 'en') {
		return category.name;
	}

	return category.i18N.DE;
}
